
import { createClient } from '@supabase/supabase-js'

const supabaseUrl = "https://gcyljkaelmuicdltfonh.supabase.co"
const supabaseAnonKey = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImdjeWxqa2FlbG11aWNkbHRmb25oIiwicm9sZSI6ImFub24iLCJpYXQiOjE2ODAzOTc3MDMsImV4cCI6MTk5NTk3MzcwM30.9j-axlPTQFgQpu950LJch6DMjKo2vGfO5U6g8p5TBDM"


export const supabase = createClient(supabaseUrl, supabaseAnonKey)